import { useSearchParams, Link } from 'react-router-dom';
import AuthLayout from './AuthLayout';

// The /api/verify-email endpoint does the actual work and 302s here with
// ?status=ok or ?status=expired. This page is purely informational.
export default function VerifyEmail() {
  const [params] = useSearchParams();
  const status = params.get('status');

  if (status === 'ok') {
    return (
      <AuthLayout title="Email verified" subtitle="Thanks. You can now use Nice2Job.">
        <Link to="/" className="btn accent" style={{ display: 'inline-block' }}>Go to app</Link>
      </AuthLayout>
    );
  }
  if (status === 'expired') {
    return (
      <AuthLayout
        title="Link expired"
        subtitle="This verification link is no longer valid. Sign in and request a new one from your account settings."
      >
        <Link to="/login" className="btn accent" style={{ display: 'inline-block' }}>Sign in</Link>
      </AuthLayout>
    );
  }
  // No status in URL — token in URL, fire the GET ourselves.
  const token = params.get('token');
  if (token) {
    window.location.replace(`/api/verify-email?token=${encodeURIComponent(token)}`);
    return <AuthLayout title="Verifying…"><div /></AuthLayout>;
  }
  return (
    <AuthLayout title="Nothing to verify" subtitle="No token in URL.">
      <Link to="/login" className="btn accent" style={{ display: 'inline-block' }}>Sign in</Link>
    </AuthLayout>
  );
}
